import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import FinanzasOperativasLayout from "./FinanzasOperativasLayout";
import { MENU, FINANZAS_OPERATIVAS_BASE, finanzasOperativasDefaultRoute } from "./config";

// Árbol de rutas de /finanzas-operativas derivado del MENU, como en
// Layouts/mantenimiento/routes.tsx: submenú y rutas nunca se desincronizan.
const children: RouteObject[] = [
  { index: true, element: <Navigate to={finanzasOperativasDefaultRoute} replace /> },
  ...MENU.map((item) => ({ path: item.id, element: item.element })),
];

export const finanzasOperativasRoute: RouteObject = {
  path: FINANZAS_OPERATIVAS_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      path: "",
      element: <FinanzasOperativasLayout />,
      children,
    },
  ],
};
